<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.geocoder = null;
    this.debounceTimer = null;
    this.requestId = 0;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (!this.destroyed) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val) {
        this.stopPending();
        this.items = [];
        return;
      }

      if (this.select && val === this.select.text) {
        this.stopPending();
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // beendet Timer und laufende Anfragen; spätere Antworten werden verworfen
    stopPending() {
      if (this.debounceTimer != null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      this.requestId++;
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();
      this.loading = true;

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;

        if (!this.geocoder || this.destroyed) {
          this.loading = false;
          return;
        }

        const requestId = ++this.requestId;
        this.geocoder.autocomplete(value).then(items => {
          if (this.destroyed || requestId !== this.requestId || items === null) {
            return;
          }
          this.items = items.slice();
          this.loading = false;
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
